/**
 * The Spanish dictionary: English in, Spanish out (ADR 0325).
 *
 * One file per screen, so that two people translating two screens never
 * edit the same file. A key that two screens share is written once, in the
 * file of whichever screen used it first; the merge below makes it one
 * dictionary, and a later file wins a key that two files both carry.
 * `scripts/check-spanish.mjs` holds every `t("...")` in the app to having
 * an entry here.
 *
 * House style, so the app reads as one voice:
 * - No "usted" and no "tú": the app speaks in the imperative ("Guardar",
 *   "Enviar") and in nouns, the way a tool does.
 * - Trade words the crews use: techo, cuadros (squares), teja (shingle),
 *   canalón (gutter), tapajuntas (flashing), orden de trabajo, orden de
 *   materiales, gastos, presupuesto (an estimate), propuesta (the proposal
 *   the customer signs), inspección, cliente, prospecto (a lead).
 * - Product names, brand names, job numbers, people's names and anything
 *   typed by a person are never in here.
 */

import { auth } from "./auth.js";
import { components } from "./components.js";
import { contacts } from "./contacts.js";
import { core } from "./core.js";
import { email } from "./email.js";
import { estimate } from "./estimate.js";
import { estimateForms } from "./estimateForms.js";
import { job } from "./job.js";
import { jobModals } from "./jobModals.js";
import { jobPanels } from "./jobPanels.js";
import { lists } from "./lists.js";
import { orders } from "./orders.js";
import { phone } from "./phone.js";
import { present } from "./present.js";
import { shell } from "./shell.js";
import { tools } from "./tools.js";
import { toolsMore } from "./toolsMore.js";
import { workOrders } from "./workOrders.js";

export const es: Readonly<Record<string, string>> = {
  ...core,
  ...components,
  ...shell,
  ...auth,
  ...lists,
  ...contacts,
  ...job,
  ...jobPanels,
  ...jobModals,
  ...orders,
  ...workOrders,
  ...estimate,
  ...present,
  ...estimateForms,
  ...tools,
  ...toolsMore,
  ...phone,
  ...email,
};
